import React, { useState, useEffect, useCallback, useRef } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 800,
    bgcolor: "background.paper",
    boxShadow: 24,
    zIndex: "9999999",
    borderRadius: "16px",
    p: 4,
};

function FullMessageModel({ open, handleClose, singleMessage }) {

    const handleModalClose = () => {
        handleClose();
    };


    return (
        <>
            <Modal
                open={open}
                onClose={handleModalClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                className="register-wrapper"
            >
                <Box sx={style} className="">
                    {/* header */}
                    <div className="flex place-content-between items-center border-b border-[#00000026] pb-3 mb-3">
                        <h4 className="font-bold text-[22px] text-[#4F4F4F]">
                            Full Message
                        </h4>

                        {/* <button onClick={handleModalClose}>
                            <i class="mdi mdi-close-circle"></i>
                        </button> */}
                    </div>
                    <div className="row ">
                        <div className="form-group col-md-12">
                            <label for="exampleInputName1">User Message*</label>
                            <textarea
                                rows={7}
                                type="text"
                                value={singleMessage}
                                className="form-control"
                                id="exampleInputName1"
                                placeholder=" Message*"
                                name="adminReply"
                            />
                        </div>
                    </div>

                    <button className="btn btn-outline-secondary btn-lg"
                        onClick={handleModalClose}>
                        Back
                    </button>
                </Box >
            </Modal >
        </>
    );
}

export default FullMessageModel;

